import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useBreakpointValue } from "@chakra-ui/react";
import React from "react";
import { PurchasedReports } from "screens/purchased-reports/PurchasedReports";
import { PurchasedInvoices } from "screens/purchased-invoices/PurchasedInvoices";
import { useSidebarNavigation, useTabProps } from "hooks";

export const Purchases = () => {
  const isMobile = useBreakpointValue({ base: true, md: false }, { fallback: "md", ssr: false });
  const { defaultTabProps } = useTabProps();
  const { currentSidebarType } = useSidebarNavigation();
  const isTablet = useBreakpointValue({ base: false, md: true, lg: false }, { fallback: "md", ssr: false });

  return (
    <Box
      height="calc(100vh - 3.5rem)"
      py="1rem"
      overflow="hidden"
      position="relative"
      px={isMobile || isTablet ? ".5rem" : currentSidebarType === "hidden" ? "0" : "1rem"}>
      <Tabs height="100%" display="flex" flexDirection="column">
        <TabList>
          <Tab
            {...defaultTabProps}
            mt="0"
            pt="0"
            mb={isMobile ? "0.5rem" : "0"}
            px={isMobile || isTablet ? ".5rem" : currentSidebarType === "hidden" ? "0.5rem" : "1rem"}
            width={isMobile ? "100%" : "14rem"}>
            Report Purchases
          </Tab>
          <Tab
            {...defaultTabProps}
            mt="0"
            pt="0"
            mb={isMobile ? "0.5rem" : "0"}
            px={isMobile || isTablet ? ".5rem" : currentSidebarType === "hidden" ? "0.5rem" : "1rem"}
            width={isMobile ? "100%" : "14rem"}>
            Invoices
          </Tab>
        </TabList>
        <TabPanels flex="1" overflow="hidden" pt="2rem">
          <TabPanel height="100%" p={0}>
            <PurchasedReports />
          </TabPanel>
          <TabPanel height="100%" p={0}>
            <PurchasedInvoices />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
